import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alerts, General } from 'icons/untitledui';
import * as DropdownStyled from 'theme/components/Dropdown.style';
import * as SelectionStyled from 'theme/components/SelectionDropdown.style';
import * as Styled from '../../styles/FilterGroupingControl.style';
import { GroupingKey } from './_types';

interface GroupingMenuProps {
  value: GroupingKey;
  onChange: (value: GroupingKey) => void;
}

const ORDER: GroupingKey[] = ['default', 'urgency', 'status', 'visibility'];

const ICONS: Record<GroupingKey, React.ComponentType<{ size?: number }>> = {
  default: General.Rows01,
  urgency: Alerts.AlertCircle,
  status: General.CheckCircle,
  visibility: General.Eye,
};

export default function GroupingMenu({
  value,
  onChange,
}: GroupingMenuProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  return (
    <Styled.PopoverCard>
      <Styled.List>
        <DropdownStyled.SectionHeader>
          {t('filterGrouping.grouping.title')}
        </DropdownStyled.SectionHeader>
        {ORDER.map((key) => {
          const isSelected = value === key;
          const Icon = ICONS[key];
          return (
            <SelectionStyled.Option
              key={key}
              type="button"
              $selected={isSelected}
              onClick={() => onChange(key)}
              role="menuitemradio"
              aria-checked={isSelected}
            >
              <Styled.LeadingRow>
                <DropdownStyled.ItemLeadingIcon>
                  <Icon size={20} />
                </DropdownStyled.ItemLeadingIcon>
                <span>{t(`filterGrouping.grouping.options.${key}`)}</span>
              </Styled.LeadingRow>
              <SelectionStyled.OptionCheck $selected={isSelected}>
                {isSelected && <General.Check size={16} />}
              </SelectionStyled.OptionCheck>
            </SelectionStyled.Option>
          );
        })}
      </Styled.List>
    </Styled.PopoverCard>
  );
}
